/* ============================================================
   US-Parts24 · R558 — Portal-Rundgang: Scrollstand → Szene.

   Grundregel: Der Zustand beider Geräte ist eine reine Funktion des
   Scrollstands (Kapitel + Fortschritt 0…1). Kein Autoplay, keine Uhr:
   rückwärts scrollen spult rückwärts. Übergänge zwischen zwei Zuständen
   macht CSS (kurze Transitions), das Tippen läuft Zeichen für Zeichen mit
   dem Finger mit.

   Messung nur über getBoundingClientRect — der Scroller ist ab 990 px
   `.page-wrapper` (Lenis), darunter das Fenster; scrollY taugt hier nicht
   (Lehre lenis-scrollt-per-transform). Scroll-Ereignisse fangen wir in der
   Capture-Phase am document, dann kommen beide Scroller an.

   Fällt das Skript aus: Kapitel sind normaler Text, die Geräte zeigen den
   Endzustand aus dem Markup.
   ============================================================ */
(() => {
  'use strict';

  /* Szenen je Kapitel. Jeder Eintrag: [ab Fortschritt, Änderungen].
     Änderungen werden aufsummiert; der erste Eintrag muss vollständig sein.
     ov = Liste der Schalter (Menüs, Blätter, Dateien …), ziel = data-ziel,
     auf das Zeiger/Finger zeigen, text = hervorgehobene Anleitungszeile. */
  const ABLAUF = {
    zugang: {
      fokus: 'laptop',
      tippen: { name: [0.26, 0.4], firma: [0.4, 0.54], mail: [0.54, 0.66] },
      lt: [
        [0, { modus: 'browser', view: 'login', schritt: 1, status: 0, ov: [], ziel: 'registrieren' }],
        [0.2, { view: 'register', ziel: null }],
        [0.67, { ziel: 'konto-erstellen' }],
        [0.74, { view: 'pruefung', ziel: null }],
        [0.86, { ov: ['frei'] }],
      ],
      ph: 'lt',
    },

    app: {
      fokus: 'app',
      lt: [
        [0, { modus: 'browser', view: 'login', schritt: 1, status: 0, ov: ['lt-hinweis'], ziel: null }],
        [0.06, { ziel: 'lt-install' }],
        [0.16, { ov: ['lt-install'], ziel: 'lt-installieren' }],
        [0.34, { modus: 'app', ov: ['dock'], ziel: null }],
        [0.66, { ov: [] }],
      ],
      ph: {
        ios: [
          [0, { modus: 'browser', view: 'login', schritt: 1, status: 0, ov: [], ziel: null, text: 1 }],
          [0.06, { ziel: 'ios-mehr', text: 2 }],
          [0.14, { ov: ['ios-menue'], ziel: 'ios-teilen', text: 2 }],
          [0.27, { ov: ['ios-teilen'], ziel: 'ios-home', text: 3 }],
          [0.42, { ov: ['ios-dialog'], ziel: 'ios-hinzufuegen', text: 4 }],
          [0.56, { modus: 'home', ov: ['icon-neu'], ziel: 'home-icon', text: 5 }],
          [0.76, { ov: ['icon-neu', 'oeffnen'], ziel: null }],
          [0.82, { modus: 'app', view: 'login', ov: [] }],
        ],
        android: [
          [0, { modus: 'browser', view: 'login', schritt: 1, status: 0, ov: [], ziel: null, text: 1 }],
          [0.06, { ziel: 'and-menue', text: 2 }],
          [0.16, { ov: ['and-menue'], ziel: 'and-installieren', text: 3 }],
          [0.32, { ov: ['and-dialog'], ziel: 'and-ok', text: 4 }],
          [0.5, { modus: 'home', ov: ['icon-neu'], ziel: 'home-icon', text: 5 }],
          [0.74, { ov: ['icon-neu', 'oeffnen'], ziel: null }],
          [0.8, { modus: 'app', view: 'login', ov: [] }],
        ],
      },
    },

    anfrage: {
      fokus: 'laptop',
      tippen: { vin: [0.24, 0.46], teil: [0.68, 0.82], hinweis: [0.82, 0.92] },
      lt: [
        [0, { modus: 'app', view: 'dashboard', schritt: 1, status: 0, ov: [], ziel: 'neue-anfrage' }],
        [0.1, { view: 'wizard', schritt: 1, ziel: 'weiter' }],
        [0.2, { schritt: 2, ziel: null }],
        [0.47, { ziel: 'decodieren' }],
        [0.52, { ov: ['decode'] }],
        [0.58, { ov: ['erkannt'], ziel: 'weiter' }],
        [0.65, { schritt: 3, ov: [], ziel: null }],
        [0.93, { ziel: 'weiter' }],
      ],
      ph: 'lt',
    },

    fotos: {
      fokus: 'phone',
      lt: [
        [0, { modus: 'app', view: 'wizard', schritt: 4, status: 0, ov: ['finder'], ziel: 'finder-datei' }],
        [0.18, { ov: ['finder', 'drag'], ziel: 'dropzone' }],
        [0.36, { ov: ['finder', 'datei1', 'datei2'], ziel: null }],
        [0.5, { ov: ['datei1', 'datei2'], ziel: 'absenden' }],
        [0.8, { view: 'dashboard', status: 1, ov: ['neu', 'toast'], ziel: null }],
      ],
      ph: [
        [0, { modus: 'app', view: 'wizard', schritt: 4, status: 0, ov: [], ziel: 'dropzone' }],
        [0.12, { ov: ['foto-sheet'], ziel: 'foto-aufnehmen' }],
        [0.26, { ov: ['kamera'], ziel: 'ausloeser' }],
        [0.42, { ov: ['kamera', 'geschossen'], ziel: 'foto-verwenden' }],
        [0.56, { ov: ['datei1'], ziel: 'absenden' }],
        [0.8, { view: 'dashboard', status: 1, ov: ['neu', 'toast'], ziel: null }],
      ],
    },

    status: {
      fokus: 'beide',
      lt: [
        [0, { modus: 'app', view: 'dashboard', schritt: 4, status: 1, ov: ['neu'], ziel: null }],
        [0.18, { status: 2 }],
        [0.36, { status: 3, ov: ['neu', 'angebot'] }],
        [0.7, { ziel: 'angebot-ansehen' }],
      ],
      ph: [
        [0, { modus: 'sperre', view: 'dashboard', schritt: 4, status: 1, ov: ['neu'], ziel: null }],
        [0.36, { ov: ['neu', 'mitteilung'] }],
        [0.48, { ziel: 'mitteilung' }],
        [0.6, { modus: 'app', status: 3, ov: ['neu', 'angebot'], ziel: null }],
        [0.8, { ziel: 'angebot-ansehen' }],
      ],
    },
  };

  const schmalMq = window.matchMedia('(max-width: 989px)');
  const nurHandyMq = window.matchMedia('(max-width: 699px)');
  const klemmen = (v) => (v < 0 ? 0 : v > 1 ? 1 : v);

  function starten(wurzel) {
    if (!wurzel || wurzel.dataset.uptLaeuft) return;
    wurzel.dataset.uptLaeuft = '1';

    const buehne = wurzel.querySelector('[data-upt-buehne]');
    const kapitel = [...wurzel.querySelectorAll('[data-upt-k]')].filter((k) => ABLAUF[k.dataset.uptK]);
    if (!buehne || !kapitel.length) return;

    const geraete = {
      lt: wurzel.querySelector('[data-upt-geraet="lt"]'),
      ph: wurzel.querySelector('[data-upt-geraet="ph"]'),
    };
    const zeiger = {
      lt: geraete.lt && geraete.lt.querySelector('.upt-zeiger'),
      ph: geraete.ph && geraete.ph.querySelector('.upt-finger'),
    };
    const teile = [...wurzel.querySelectorAll('.upt-fortschritt__teil i')];
    const felder = [...wurzel.querySelectorAll('[data-tippen]')].map((el) => ({
      el,
      key: el.dataset.tippen,
      text: el.textContent,
      stand: -1,
    }));

    /* Wem gehört welches Tipp-Feld? (Kapitel-Index) */
    const tippEigner = {};
    kapitel.forEach((k, i) => {
      const t = ABLAUF[k.dataset.uptK].tippen || {};
      Object.keys(t).forEach((key) => {
        if (!(key in tippEigner)) tippEigner[key] = i;
      });
    });

    let plattform = /Android/i.test(navigator.userAgent) ? 'android' : 'ios';
    const letzte = {
      lt: { kap: -1, idx: -1, ziel: null },
      ph: { kap: -1, idx: -1, ziel: null },
    };
    const timer = { lt: [], ph: [] };
    let aktivKap = -1;
    let sichtbar = true;
    let geplant = false;

    /* Datum auf dem Sperrbildschirm = heute */
    const datum = wurzel.querySelector('[data-upt-datum]');
    if (datum) {
      try {
        datum.textContent = new Date().toLocaleDateString('de-DE', { weekday: 'long', day: 'numeric', month: 'long' });
      } catch (_) { /* bleibt „Heute" */ }
    }

    function plattformSetzen(neu) {
      plattform = neu === 'android' ? 'android' : 'ios';
      wurzel.dataset.plattform = plattform;
      wurzel.querySelectorAll('[data-upt-plattform]').forEach((b) => {
        b.setAttribute('aria-pressed', String(b.dataset.uptPlattform === plattform));
      });
      letzte.ph.kap = -1;
      takt();
    }
    wurzel.querySelectorAll('[data-upt-plattform]').forEach((b) => {
      b.addEventListener('click', () => plattformSetzen(b.dataset.uptPlattform));
    });

    function szenen(kapId, g) {
      const a = ABLAUF[kapId];
      let s = a[g];
      if (s === 'lt') s = a.lt;
      if (s && !Array.isArray(s)) s = s[plattform] || s.ios;
      return s || [];
    }

    /* Puffer gegen Flattern: Rückwärts wechselt eine Szene erst, wenn der
       Fortschritt die Schwelle um PUFFER unterschreitet. Sonst springt der
       Bildschirm am Handy hin und her, sobald Safari beim Scrollen minimal
       nachfedert (R558 Runde 2, Marcel: „mobil stabiler“). */
    const PUFFER = 0.025;
    function zustand(liste, p, vorIdx) {
      let idx = 0;
      for (let i = 1; i < liste.length; i++) {
        if (p >= liste[i][0]) idx = i;
        else break;
      }
      if (vorIdx != null && idx < vorIdx && vorIdx < liste.length && p > liste[vorIdx][0] - PUFFER) idx = vorIdx;
      let z = {};
      for (let i = 0; i <= idx; i++) z = Object.assign({}, z, liste[i][1]);
      return { z, idx };
    }

    function zeigerErlaubt(g, fokus) {
      if (nurHandyMq.matches) return g === 'ph';
      return fokus === 'beide' || fokus === 'app' || (fokus === 'laptop' && g === 'lt') || (fokus === 'phone' && g === 'ph');
    }

    function zielPunkt(g, ziel) {
      const geraet = geraete[g];
      if (!geraet || !ziel) return null;
      const el = geraet.querySelector(`[data-ziel~="${ziel}"]`);
      if (!el) return null;
      const r = el.getBoundingClientRect();
      if (!r.width && !r.height) return null;
      const s = geraet.getBoundingClientRect();
      const skala = geraet.offsetWidth ? s.width / geraet.offsetWidth : 1;
      if (!skala) return null;
      return {
        x: (r.left + r.width / 2 - s.left) / skala,
        y: (r.top + r.height / 2 - s.top) / skala,
      };
    }

    function zeigerStellen(g, ziel, erlaubt) {
      const z = zeiger[g];
      if (!z) return;
      const punkt = erlaubt ? zielPunkt(g, ziel) : null;
      if (!punkt) {
        z.classList.add('is-weg');
        return;
      }
      z.classList.remove('is-weg');
      z.style.transform = `translate(${punkt.x.toFixed(1)}px, ${punkt.y.toFixed(1)}px)`;
    }

    function klicken(g) {
      const z = zeiger[g];
      if (!z || z.classList.contains('is-weg')) return;
      z.classList.remove('is-klick');
      void z.offsetWidth; // Animation neu starten
      z.classList.add('is-klick');
      setTimeout(() => z.classList.remove('is-klick'), 520);
    }

    function anwenden(g, kapIdx, z, idx, fokus) {
      const el = geraete[g];
      if (!el) return;
      const l = letzte[g];
      const vorwaerts = kapIdx === l.kap && idx > l.idx;
      const erlaubt = zeigerErlaubt(g, fokus);

      /* Klick: das Ziel der vorigen Szene hat die neue ausgelöst */
      if (vorwaerts && l.ziel && erlaubt) klicken(g);

      const werte = {
        modus: z.modus || 'app',
        view: z.view || 'dashboard',
        schritt: String(z.schritt || 1),
        status: String(z.status || 0),
        ov: (z.ov || []).join(' '),
      };
      Object.keys(werte).forEach((k) => {
        if (el.dataset[k] !== werte[k]) el.dataset[k] = werte[k];
      });

      const neueSzene = kapIdx !== l.kap || idx !== l.idx;
      l.kap = kapIdx;
      l.idx = idx;
      l.ziel = z.ziel || null;

      if (neueSzene) {
        /* Nachmessen, wenn Blätter/Menüs ihre Bewegung beendet haben */
        timer[g].forEach(clearTimeout);
        zeigerStellen(g, l.ziel, erlaubt);
        timer[g] = [90, 480].map((ms) => setTimeout(() => zeigerStellen(g, l.ziel, zeigerErlaubt(g, fokus)), ms));
      }
    }

    function tippen(kapIdx, p) {
      const spec = ABLAUF[kapitel[kapIdx].dataset.uptK].tippen || {};
      felder.forEach((f) => {
        const eigner = tippEigner[f.key];
        let anteil;
        if (eigner === undefined) anteil = 1;
        else if (eigner < kapIdx) anteil = 1;
        else if (eigner > kapIdx) anteil = 0;
        else {
          const [a, b] = spec[f.key];
          anteil = klemmen((p - a) / (b - a));
        }
        const n = Math.round(anteil * f.text.length);
        if (n === f.stand) return;
        f.stand = n;
        f.el.textContent = f.text.slice(0, n);
        f.el.classList.toggle('is-tippt', n > 0 && n < f.text.length);
      });
    }

    function anleitung(kapEl, text) {
      if (!kapEl) return;
      kapEl.querySelectorAll(`.upt-anleitung--${plattform} [data-upt-schritt]`).forEach((li) => {
        const n = Number(li.dataset.uptSchritt);
        li.classList.toggle('is-jetzt', n === text);
        li.classList.toggle('is-fertig', n < text);
      });
    }

    /* Stabile Bildschirmhöhe: 100svh ändert sich NICHT, wenn Safari seine
       Adressleiste ein- und ausfährt — innerHeight schon (um ~80 px), und
       damit sprang die Lesezeile und mit ihr die Szene. */
    const sonde = document.createElement('div');
    sonde.setAttribute('aria-hidden', 'true');
    sonde.style.cssText = 'position:absolute;left:0;top:0;width:1px;height:100vh;height:100svh;visibility:hidden;pointer-events:none;';
    wurzel.appendChild(sonde);
    let svh = sonde.offsetHeight || window.innerHeight;
    let breite = window.innerWidth;

    function leselinie() {
      if (schmalMq.matches) {
        const b = buehne.getBoundingClientRect();
        const unten = Math.max(0, Math.min(b.bottom, svh));
        return unten + (svh - unten) * 0.35;
      }
      return svh * 0.5;
    }

    /* Seitenkopf der Website: fährt beim Hochscrollen über die stehende
       Bühne (am iPhone 60 px über Statusleiste und Insel). Dann rückt das
       Gerät weich darunter, statt verdeckt zu werden. */
    const kopf = document.querySelector('header-component, #header-component, .header');
    const geraeteBox = buehne.querySelector('.upt-geraete');
    let kopfAnteil = -1;
    function kopfMessen() {
      if (!kopf || !geraeteBox) return 0;
      const cs = getComputedStyle(kopf);
      if (cs.visibility === 'hidden' || parseFloat(cs.opacity) < 0.5) return 0;
      const kb = kopf.getBoundingClientRect().bottom;
      if (kb <= 0) return 0;
      const oben = buehne.getBoundingClientRect().top + geraeteBox.offsetTop;
      const hoehe = geraeteBox.offsetHeight || 1;
      const a = (kb + 6 - oben) / hoehe;
      return a > 0 ? Math.min(0.3, a) : 0;
    }
    if (kopf && 'MutationObserver' in window) {
      new MutationObserver(() => { anfordern(); setTimeout(anfordern, 380); })
        .observe(kopf, { attributes: true, attributeFilter: ['data-sticky-state', 'class', 'style'] });
    }

    function takt() {
      geplant = false;
      const linie = leselinie();
      let k = 0;
      for (let i = 0; i < kapitel.length; i++) {
        if (kapitel[i].getBoundingClientRect().top <= linie) k = i;
      }
      /* Puffer auch zwischen Kapiteln: zurück erst 24 px hinter der Kante */
      if (aktivKap > 0 && k === aktivKap - 1 && kapitel[aktivKap].getBoundingClientRect().top <= linie + 24) k = aktivKap;
      const anteil = kopfMessen();
      const r = kapitel[k].getBoundingClientRect();
      const p = klemmen((linie - r.top) / Math.max(1, r.height));
      const kapId = kapitel[k].dataset.uptK;
      const a = ABLAUF[kapId];

      if (k !== aktivKap) {
        kapitel.forEach((el, i) => el.classList.toggle('is-aktiv', i === k));
        buehne.dataset.fokus = a.fokus || 'beide';
        aktivKap = k;
      }
      const gerundet = Math.round(anteil * 100) / 100;
      if (gerundet !== kopfAnteil) {
        kopfAnteil = gerundet;
        buehne.classList.toggle('is-kopf', gerundet > 0);
        buehne.style.setProperty('--upt-kopf-anteil', String(gerundet));
      }
      teile.forEach((t, i) => {
        const f = i < k ? 1 : i > k ? 0 : p;
        t.style.setProperty('--f', f.toFixed(3));
      });

      tippen(k, p);
      let text = 0;
      ['lt', 'ph'].forEach((g) => {
        const vorIdx = letzte[g].kap === k ? letzte[g].idx : null;
        const { z, idx } = zustand(szenen(kapId, g), p, vorIdx);
        if (g === 'ph' && z.text) text = z.text;
        anwenden(g, k, z, idx, a.fokus);
      });
      if (kapId === 'app') anleitung(kapitel[k], text);
    }

    function anfordern() {
      if (!sichtbar || geplant) return;
      geplant = true;
      requestAnimationFrame(() => geplant && takt());
      /* Rückfall: Manche Umgebungen liefern keine Bildtakte (verdeckte Tabs,
         eingebettete Browser) — dann läuft der Takt eben ohne sie. */
      setTimeout(() => geplant && takt(), 120);
    }

    /* Bilder der Bühne vorladen, sobald der Rundgang naht. Sonst lädt z. B.
       das Kamerabild erst, wenn die Kamera-Szene schon zu sehen ist
       (loading="lazy" in einem ausgeblendeten Teil lädt nie vorher). */
    let vorgeladen = false;
    function vorladen() {
      if (vorgeladen) return;
      vorgeladen = true;
      buehne.querySelectorAll('img').forEach((img) => {
        img.loading = 'eager';
        img.decoding = 'async';
      });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        (eintraege) => {
          sichtbar = eintraege.some((e) => e.isIntersecting);
          if (sichtbar) { vorladen(); anfordern(); }
        },
        { rootMargin: '600px 0px 600px 0px' }
      ).observe(wurzel);
    } else {
      vorladen();
    }
    document.addEventListener('scroll', anfordern, { passive: true, capture: true });
    window.addEventListener('resize', () => {
      /* Nur die Höhe geändert = Safari-Leiste ein/aus → nichts neu aufsetzen */
      if (window.innerWidth === breite) { anfordern(); return; }
      breite = window.innerWidth;
      svh = sonde.offsetHeight || window.innerHeight;
      letzte.lt.kap = -1;
      letzte.ph.kap = -1;
      anfordern();
    });
    schmalMq.addEventListener?.('change', () => { svh = sonde.offsetHeight || window.innerHeight; letzte.lt.kap = -1; letzte.ph.kap = -1; anfordern(); });

    wurzel.classList.add('is-bereit');
    plattformSetzen(plattform);
  }

  function alle() {
    document.querySelectorAll('[data-usp-tour]').forEach(starten);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle, { once: true });
  else alle();
  /* Theme-Editor: neu gerenderte Section wieder anwerfen */
  document.addEventListener('shopify:section:load', (e) => starten(e.target.querySelector('[data-usp-tour]')));
})();
